module.exports = __webpack_public_path__ + "img/project16_3.jpg.bf256da0.webp";